export const PeriodEnum: { [key: number]: string } = {
    0: 'Anual',
    1: 'Primeiro Trimestre',
    2: 'Segundo Trimestre',
    3: 'Terceiro Trimestre',
    4: 'Quarto Trimestre',
}